import { FC, useState } from "react";
import type { RaffleTier } from "entities/wheel-raffle";
import { sortTiers } from "../model/tierThreshold";
import { LabeledInput } from "./LabeledInput";
import { Popover } from "./Popover";

import styles from "./TierThresholdPicker.module.css";

interface Props {
  tiers: RaffleTier[];
  value: string;
  error?: string;
  disabled?: boolean;
  onChange: (tierCode: string) => void;
}

// Наведённый (или выбранный) статус и все ниже по списку подсвечены —
// именно они и допускаются к участию.
export const TierThresholdPicker: FC<Props> = ({
  tiers,
  value,
  error,
  disabled,
  onChange,
}) => {
  const [hovered, setHovered] = useState<number | null>(null);
  const sorted = sortTiers(tiers);
  const selectedIndex = sorted.findIndex((tier) => tier.tier_code === value);
  const activeIndex = hovered ?? selectedIndex;
  const selected = sorted[selectedIndex];

  const getClassName = (index: number) =>
    [
      styles.tier,
      activeIndex >= 0 && index >= activeIndex ? styles.lit : "",
      index === selectedIndex ? styles.selected : "",
    ].join(" ");

  return (
    <LabeledInput label="Min. status">
      <Popover
        summary={
          selected ? `${selected.display_name} and higher` : "Select status"
        }
        error={error}
        disabled={disabled}
      >
        {(close) => (
          <ul className={styles.list} onMouseLeave={() => setHovered(null)}>
            {sorted.map((tier, index) => (
              <li key={tier.tier_code}>
                <button
                  type="button"
                  className={getClassName(index)}
                  aria-pressed={index === selectedIndex}
                  onMouseEnter={() => setHovered(index)}
                  onFocus={() => setHovered(index)}
                  onClick={() => {
                    onChange(tier.tier_code);
                    close();
                  }}
                >
                  {tier.display_name}
                </button>
              </li>
            ))}
          </ul>
        )}
      </Popover>
    </LabeledInput>
  );
};
